import { Typography } from "@/components/app";
import { Link } from "react-router-dom";
import Logo from "@/components/icons/Logo";
import { motion } from "framer-motion";
import {
  fadeLeft,
  fadeRight,
  fadeUp,
  staggerContainer,
  viewportOnce,
} from "@/lib/animations";

export function DownloadAppSection() {
  return (
    <section id="download-app" className="py-6 md:py-10 lg:py-12 ">
      <div className="wrapper">
        <motion.div
          className="bg-primary rounded-3xl overflow-hidden"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <div className="flex flex-wrap sm:bg-[url('/images/girl-img.webp')] bg-right bg-no-repeat bg-contain">
            {/* Left Content */}
            <motion.div
              className="w-full sm:w-[70%] order-2 sm:order-1 p-8 md:p-12 lg:p-16"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
            >
              <div className="space-y-4 lg:space-y-6">
                <motion.div
                  variants={fadeLeft}
                  className="w-[172px] lg:w-[230px] text-white"
                >
                  <Logo isCollapsed={false} />
                </motion.div>

                {/* <motion.div variants={fadeLeft}>
                  <Typography variant="h2" className="text-background">
                    Download the Jewellery App Today
                  </Typography>
                </motion.div> */}

                <motion.div variants={fadeLeft}>
                  <Typography variant="body1" className="text-background/80">
                    Shop beautiful gold and silver jewellery anytime, anywhere.
                    Join 10,000+ happy customers.
                  </Typography>
                </motion.div>

                {/* <motion.div variants={fadeLeft} className="flex flex-wrap gap-4 pt-4">
                  <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
                    <Link to="/" className="inline-block">
                      <img src="/images/apple-store.webp" alt="Download on App Store" className="md:w-[192px] w-auto h-10 md:h-[57px]" />
                    </Link>
                  </motion.div>
                  <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
                    <Link to="/" className="inline-block">
                      <img src="/images/play-store.webp" alt="Get it on Google Play" className="md:w-[192px] w-auto h-10 md:h-[57px]" />
                    </Link>
                  </motion.div>
                </motion.div> */}
              </div>
            </motion.div>

            <motion.div
              className="sm:hidden w-full sm:w-[30%] order-1 sm:order-2"
              variants={fadeRight}
              initial="hidden"
              whileInView="visible"
              viewport={viewportOnce}
            >
              <div className="max-w-[350px] mx-auto md:max-w-full">
                <img
                  src="/images/girl-img.webp"
                  alt=""
                  className="w-full h-full object-contain"
                />
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
